import styled from "@emotion/styled";
import { formInputTheme, TextInputRootBoxProps } from "./formInputTheme";

type StyledContentBeforeContainerProps = Pick<
    TextInputRootBoxProps,
    "themeMode" | "validationState" | "isFocused" | "focusMode" | "variant"
>;

// not using sizing constant due to the 2px border (would be 12/sizes.small)
export const StyledContentBeforeContainer = styled("div")<StyledContentBeforeContainerProps>`
    padding-left: ${getPadding};
    padding-right: var(--sds--form-input--content-before--padding--right, 0px);
    display: flex;
`;

function getPadding({ themeMode, validationState, isFocused, focusMode, variant }: StyledContentBeforeContainerProps) {
    //underline paddings don't change based on state
    if (variant === "underline") return `${formInputTheme.padding.left.rest(themeMode)}`;
    if ((isFocused && focusMode !== "keyboard") || validationState === "error") {
        return `${formInputTheme.padding.left.active(themeMode)}`;
    }
    return `${formInputTheme.padding.left.rest(themeMode)}`;
}
